const IconViewWeek = ({ fillColor = "inherit", size = "24px" }) => {
  return (
    <svg height={size} width={size} viewBox="0 -960 960 960" fill={fillColor}>
      <path d="M140-220h187v-520H140v520Zm247 0h186v-520H387v520Zm246 0h187v-520H633v520Zm-493 60q-24 0-42-18t-18-42v-520q0-24 18-42t42-18h680q24 0 42 18t18 42v520q0 24-18 42t-42 18H140Z" />
    </svg>
  );
};

export default IconViewWeek;
